import { render } from "./About.vue?vue&type=template&id=095eb7de"
const script = {}
script.render = render

export default script